import { BlogAuthorDto } from '@/components/BlogPage/types';
import { AUTHOR_KNOWS_ABOUT } from '@/constants/author-schema';
import { getAuthorEntityId, getAuthorUrl, ORGANIZATION_ENTITY_ID } from '@/constants/schema-ids';
import { extractPlainTextFromBlocksContent } from '@/lib/blocks-content';

const DESCRIPTION_MAX_LENGTH = 200;

const truncateDescription = (text: string): string => {
	if (text.length <= DESCRIPTION_MAX_LENGTH) return text;

	return `${text.slice(0, DESCRIPTION_MAX_LENGTH - 3).trimEnd()}...`;
};

const getLinkedInUrl = (socials: BlogAuthorDto['socials']): string | undefined =>
	socials.find(social => social.name === 'linkedin')?.url;

export const buildPersonJsonLd = (author: BlogAuthorDto) => {
	const slug = author.seo.url;
	const authorUrl = getAuthorUrl(slug);
	const linkedInUrl = getLinkedInUrl(author.socials);
	const description = truncateDescription(extractPlainTextFromBlocksContent(author.description));
	const knowsAbout = AUTHOR_KNOWS_ABOUT[slug];

	return {
		'@context': 'https://schema.org',
		'@type': 'Person',
		'@id': getAuthorEntityId(slug),
		name: author.name,
		url: authorUrl,
		...(author.avatar?.url ? { image: author.avatar.url } : {}),
		jobTitle: author.role,
		worksFor: {
			'@type': 'Organization',
			'@id': ORGANIZATION_ENTITY_ID
		},
		...(linkedInUrl ? { sameAs: [linkedInUrl] } : {}),
		...(knowsAbout?.length ? { knowsAbout: [...knowsAbout] } : {}),
		...(description ? { description } : {})
	};
};
